// extracted by mini-css-extract-plugin
module.exports = {"verifyButton":"corporate_verifyButton__12LXQ","rejected":"corporate_rejected__swAeg"};